/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputCriteriaTextComponent} from './input-criteria-text.component';
import {FormsModule} from '@angular/forms';
import {NumbersOnlyDirective} from './directives/numbers-only.directive';

@NgModule({
    declarations: [
        InputCriteriaTextComponent,
        NumbersOnlyDirective
    ],
    exports: [
        InputCriteriaTextComponent
    ],
    imports: [
        CommonModule,
        FormsModule
    ]
})
export class InputCriteriaTextModule {
}
